import React, { useRef } from "react"
import { useSpring, animated } from "react-spring"

import * as easings from 'd3-ease'

const Wave = () => {
  const pathRef = useRef()
  const { shape } = useSpring({
    loop: { reverse: true },
    reset: true,
    from: {
      shape:
        "M0 393.346C0 393.346 272.139 413.222 358.634 412.78C445.129 412.338 637.431 394.049 848.529 331.678C1003.26 285.959 1258.26 105.585 1398.17 24.9866C1448.81 -4.1797 1508 0.238932 1508 0.238932V588H0V393.346Z",
    },
    to: {
      shape:
        "M0 367C0 367 255.505 313.442 342 313C626 311.549 663.5 384.327 848.529 331.678C1056.5 272.5 1266 190 1393.5 74C1459 14.4077 1508 0.238892 1508 0.238892V588H0V367Z",
    },
    config: { duration: 5000, easing: easings.easeSinInOut },
  })

  return (
    <svg viewBox="0 0 1508 588" fill="none" xmlns="http://www.w3.org/2000/svg">
      <animated.path d={shape} fill="url(#paint0_linear)" ref={pathRef} />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="754"
          y1="0"
          x2="754"
          y2="588"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EF5A4B" />
          <stop offset="1" stopColor="#C32B5E" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default Wave
